<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"900px"'

    :cpntOnFecharDialog='venEditarCabecalhoAlterarVeiPetFechar'>
    <template slot='titulo'>
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      <template v-if="cpntDemanda === 'venda'">
        <template v-if="cpntTipo === 'contato'">
          Alterando contato da venda {{ cpntDemandaId }}
        </template>
        <template v-else-if="cpntTipo === 'veiculo'">
          Alterando veículo da venda {{ cpntDemandaId }}
        </template>
        <template v-else-if="cpntTipo === 'pet'">
          Alterando pet da venda {{ cpntDemandaId }}
        </template>
      </template>
      <template v-else-if="cpntDemanda === 'compra'">
        <template v-if="cpntTipo === 'contato'">
          Alterando contato da compra {{ cpntDemandaId }}
        </template>
      </template>
    </template>

    <template slot='conteudo'>
      <div class="ven-edi-cab-trocar-cad">
        <!-- <table v-if="(cpntTipo === 'veiculo' && cpntVendaDados.id_con !== cpntVendaDados.id_vei_id_con) || (cpntTipo === 'pet' && cpntVendaDados.id_con !== cpntVendaDados.id_pet_id_con)">
          <tr>  
            <td colspan="2" class="caption">
              CONTATO ATUAL
              <template v-if="cpntVendaDados.status === '2'">
                DA VENDA
              </template>
              <template v-else-if="cpntVendaDados.status === '1'">
                DO ORÇAMENTO
              </template>
            </td>
          </tr>
          <tr>
            <td>
              <div class="titulo">Contato:</div>
              <div class="valor" v-html="cpntVendaDados.id_con_nome"></div>
            </td>
            <td>
              <div class="titulo">{{ cpntVendaDados.id_con_pessoa === 'f' ? 'CPF' : 'CNPJ' }}:</div>
              <div class="valor" v-html="cpntVendaDados.id_con_cnpj_cpf"></div>
            </td>
          </tr>
        </table>

        <table v-if="[ '', null, undefined ].indexOf(contato) === -1 && Object.keys(contato).length >= 1">
          <template v-if="cpntTipo === 'veiculo'">
            <tr>
              <td colspan="5" class="caption">
                VEÍCULO ATUAL
                <template v-if="cpntVendaDados.status === '2'">
                  DA VENDA
                </template>
                <template v-else-if="cpntVendaDados.status === '1'">
                  DO ORÇAMENTO
                </template>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="titulo">Proprietário:</div>
                <div class="valor" v-html="contato.nome"></div>
              </td>
              <td colspan="1">
                <div class="titulo">{{ contato.pessoa === 'f' ? 'CPF' : 'CNPJ' }}:</div>
                <div class="valor" v-html="contato.cnpj_cpf"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="titulo">Placa:</div>
                <div class="valor" v-html="cpntVendaDados.id_vei_placa"></div>
              </td>
              <td colspan="2">
                <div class="titulo">Marca:</div>
                <div class="valor" v-html="cpntVendaDados.id_vei_id_mar_nome"></div>
              </td>
              <td colspan="2">
                <div class="titulo">Modelo:</div>
                <div class="valor" v-html="cpntVendaDados.id_vei_id_mod_nome"></div>
              </td>
            </tr>
          </template>
          <template v-else-if="cpntTipo === 'pet'">
            <tr>
              <td colspan="5" class="caption">
                PET ATUAL
                <template v-if="cpntVendaDados.status === '2'">
                  DA VENDA
                </template>
                <template v-else-if="cpntVendaDados.status === '1'">
                  DO ORÇAMENTO
                </template>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <div class="titulo">Proprietário:</div>
                <div class="valor" v-html="contato.nome"></div>
              </td>
              <td colspan="1">
                <div class="titulo">{{ contato.pessoa === 'f' ? 'CPF' : 'CNPJ' }}:</div>
                <div class="valor" v-html="contato.cnpj_cpf"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="titulo">Nome:</div>
                <div class="valor" v-html="cpntVendaDados.id_pet_nome"></div>
              </td>
              <td colspan="2">
                <div class="titulo">Espécie:</div>
                <div class="valor" v-html="cpntVendaDados.id_pet_id_pet_subespecie_id_especie_especie"></div>
              </td>
              <td colspan="2">
                <div class="titulo">Raça:</div>
                <div class="valor" v-html="cpntVendaDados.id_pet_subespecie_nome"></div>
              </td>
            </tr>
          </template>
        </table> -->

        <!-- :cpntFiltros="[ { f: 'id_con_nome', o: '=', v: cpntVendaDados.id_con } ]" -->
        <App-Contato-Gerenciar v-if="cpntTipo === 'contato'"
        :cpntMostrarAniv="false"
        :cpntNovoCadastroTpCon="cpntDemanda === 'venda' ? '1' : '2'"
        :cpntSelecionar="venEditarCabecalhoAlterarVeiPetSelecionar"
        ></App-Contato-Gerenciar>

        <App-Veiculo-Gerenciar v-else-if="cpntTipo === 'veiculo'"
        :cpntFiltros="[ { f: 'id_con_nome', o: '=', v: cpntContatoId } ]"
        :cpntSelecionar="venEditarCabecalhoAlterarVeiPetSelecionar"
        ></App-Veiculo-Gerenciar>

        <App-Pet-Gerenciar v-else-if="cpntTipo === 'pet'"
        :cpntFiltros="[ { f: 'id_con_nome', o: '=', v: cpntContatoId } ]"
        :cpntSelecionar="venEditarCabecalhoAlterarVeiPetSelecionar"
        ></App-Pet-Gerenciar>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .ven-edi-cab-trocar-cad > .con-ger,
  .ven-edi-cab-trocar-cad > .pet-ger,
  .ven-edi-cab-trocar-cad > .vei-ger {
    padding-top: 0px;
  }
</style>

<style>
.ven-edi-cab-trocar-cad > .con-ger > div > .cpnt-filtro-base,
.ven-edi-cab-trocar-cad > .pet-ger > div > .cpnt-filtro-base,
.ven-edi-cab-trocar-cad > .vei-ger > div > .cpnt-filtro-base {
  margin-top: 0px;
}
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntDemandaId: {
        required: false
      },
      cpntContatoId: {
        required: true,
        type: String
      },
      cpntTipo: {
        required: true,
        type: String
      },
      cpntFecharFormulario: {
        required: true
      },
    },
    components: {
      // 'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Busca-Telas.vue')
      'App-Contato-Gerenciar': () => import('@/components/contato/gerenciar/Contato-Gerenciar.vue'),
      'App-Veiculo-Gerenciar': () => import('@/components/veiculo/gerenciar/Veiculo-Gerenciar.vue'),
      'App-Pet-Gerenciar': () => import('@/components/pet/gerenciar/Pet-Gerenciar.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        contato: null,
        filtros: {}
      }
    },
    mounted: function () {
      this.venEditarCabecalhoAlterarVeiPetIniciar()
    },
    methods: {
      venEditarCabecalhoAlterarVeiPetIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.venEditarCabecalhoAlterarVeiPetSetarStatusGeral('carregando')

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(this, {
          venEditarCabecalhoAlterarVeiPetBuscarContato: [ ],
          venEditarCabecalhoAlterarVeiPetFinalizar: [ 'venEditarCabecalhoAlterarVeiPetBuscarContato' ]
        },
        {
          venEditarCabecalhoAlterarVeiPetBuscarContato: function (chave, callback, self) { self.venEditarCabecalhoAlterarVeiPetBuscarContato(function () { callback(chave) } ) },
          venEditarCabecalhoAlterarVeiPetFinalizar: function (chave, callback, self) { self.venEditarCabecalhoAlterarVeiPetFinalizar(function () { callback(chave) } ) },
        })
      },
      venEditarCabecalhoAlterarVeiPetFechar: function (atualizar, id = null, dados = {}) {
        this.cpntFecharFormulario(atualizar, id, dados)
      },
      venEditarCabecalhoAlterarVeiPetSelecionar: function (dados) {
        this.venEditarCabecalhoAlterarVeiPetFechar(true, dados.id, dados)
      },
      venEditarCabecalhoAlterarVeiPetSetarStatusGeral: function (status) {
        // SETA O STATUS DA PAGINA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venEditarCabecalhoAlterarVeiPetBuscarContato: function (callback = null) {
        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

        // SETA OS CAMPOS QUE DEVEM RETORNAR
        queryGet.field = { nome: null, cnpj_cpf: null, pessoa: null }

        // SETA O WHERE QUEDEVE REALIZAR
        switch (this.cpntTipo) {
          case 'veiculo':
            queryGet.where = { f: 'id', o: '=', v: this.cpntContatoId }
            break

          case 'pet':
            queryGet.where = { f: 'id', o: '=', v: this.cpntContatoId }
            break
        }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (apiSuccess) => {
          // SETA OS DADOS DO CONTATO
          this.contato = apiSuccess.data[0]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null) {
            callback()
          }
        }, this.venEditarCabecalhoAlterarVeiPetSetarStatusGeral)
      },
      venEditarCabecalhoAlterarVeiPetFinalizar: function (callback = null) {
        // SETA O STATUS DA PAGINA
        this.venEditarCabecalhoAlterarVeiPetSetarStatusGeral('')

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null) {
          callback()
        }
      }
    }
  }
</script>
